import { Component, OnInit, Input, OnDestroy, Inject, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataInputOption }  from '@trivelope/triv-ui-tools-lib';
import { User, UserRoles } from 'src/app/classes/user';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { UserService, UserUpdateError } from 'src/app/services/user.service';
import { debounceTime, distinctUntilChanged, filter, map, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Environment } from 'src/app/classes/environment';
import { MemberService } from 'src/app/services/member.service';


@Component( {
	selector: 'app-user-editor',
	templateUrl: './user-editor.component.html',
	styleUrl: './user-editor.component.scss'
} )
export class UserEditorComponent implements OnInit, OnDestroy, AfterViewInit {


	_user = new User();
	@Input() set user( val: User ) {
		this._user = val;
		if( this._user ) {
			if( !this._user.ebeVorname ) this._user.ebeVorname = "";
			if( !this._user.ebeName ) this._user.ebeName = "";
			if( !this._user.ebeMail ) this._user.ebeMail = "";
		}
		this.setValueForm();
	}
	get user() {
		return this._user;
	}

	@Output() reloadUser = new EventEmitter<boolean>();

	emailCtrl = new FormControl( "", [ Validators.required, Validators.email ] );
	formG1 = new FormGroup( {
		ebeId: new FormControl( "" ),
		ebeVorname: new FormControl( "" ),
		ebeName: new FormControl( "" ),
		ebeMail: this.emailCtrl,
		mitgliedId: new FormControl<DataInputOption|null>( null ),
		ansStrasse: new FormControl( "" ),
		ansHausnummer: new FormControl( "" ),
		ansPlz: new FormControl( "" ),
		ansOrt: new FormControl( "" ),
		ebeAktiv: new FormControl( false ),
		bMaintenanceRights: new FormControl( false ),
		bAdminMember: new FormControl( false ),
		bExportRights: new FormControl( false ),
		ebeAnrede: new FormControl<DataInputOption|null>( null ),
		ebeTitel: new FormControl<DataInputOption|null>( null ),
		ebePosition: new FormControl( "" ),
		ebeTelefon: new FormControl( "" ),
	});
	@Input() myInputs: { [name: string]: DataInput } = {};
	mainContactCtrl = new FormControl( { value: false, disabled: true } );

	bInProgress = false;
	subscriptions = new Subscription();
	UserRoles = UserRoles;
	readonly FORM_DEBOUNCE_MS = 1500;
	readonly MAIN_CONTACT_DEBOUNCE_MS = 500;

	@Output() done = new EventEmitter<User>();
	@Output() mainPartnerChanged = new EventEmitter<boolean>();

	bSaveError = false;


	constructor(
		private userService: UserService,
		public matDialog: MatDialog,
		@Inject( "environment" ) public environment: Environment,
		private memberService: MemberService
	) {}


	ngOnInit() {

		setTimeout( () => {
			this.formG1.get( "ebeId" )?.disable( { emitEvent: false } );
			this.setValueForm();
		}, 10 );

	}

	ngAfterViewInit(): void {

		this.subscriptions.add(
			this.formG1.valueChanges.pipe(
				filter( v => {
					this.formG1.markAsTouched( { emitEvent: false });
					this.formG1.get('mitgliedId')?.markAsTouched( { emitEvent: false });
					this.formG1.get('ebeAnrede')?.markAsTouched( { emitEvent: false });
					return this.formG1.valid;
				} ),
				debounceTime(this.FORM_DEBOUNCE_MS),
				distinctUntilChanged(),
				switchMap( v => this.saveUserObject() )
			).subscribe()
		);

		this.subscriptions.add(
			this.mainContactCtrl.valueChanges.pipe(
				debounceTime(this.MAIN_CONTACT_DEBOUNCE_MS),
				distinctUntilChanged(),
				filter( v => !!this._user.mitgliedId ),
				switchMap( v => this.saveMainContact() )
			).subscribe()
		);

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	setValueForm() {

		if( !this.formG1.get( 'ebeName') ) return;

		// the formgroup is already initialized
		console.log( 'user', this.user )
		this.formG1.patchValue( {
				...this.user,
				ebeAktiv: (this.user.ebeAktiv == "ja"),
				mitgliedId: null,
				ebeAnrede: null,
				ebeTitel: null
			},
			{ emitEvent: false }
		);

		// console.log( "gruppen", this.user.gruppen, this.user )
		if( this.user.gruppen && this.user.gruppen.length ) {
			this.formG1.get( "bAdminMember" )?.patchValue( this.user.gruppen.includes( UserRoles.MITGLIED_ADMIN ), { emitEvent: false } );
			this.formG1.get( "bMaintenanceRights" )?.patchValue( this.user.gruppen.includes( UserRoles.MITGLIED_DATENPFLEGE ), { emitEvent: false } );
			this.formG1.get( "bExportRights" )?.patchValue( this.user.gruppen.includes( UserRoles.MITGLIED_DATENEXPORT ), { emitEvent: false } );
		}

		if( this.myInputs.mitgliedId.options ) {
			const option = this.myInputs.mitgliedId.options.find( (op:{id:string}) =>
				op.id == this.user.mitgliedId
			);
			if( option ) {
				// console.log( 'USER-EDITOR option found', option )
				// console.log( 'this.formG1.get( mitgliedId )', this.formG1.get( 'mitgliedId' ))
				const c = this.formG1.get( 'mitgliedId' );
				if( c ) {
					c.setValue( option, { emitEvent: false } );
				}
			}
		}

		if( this.user.mitgliedId ) {
			this.mainContactCtrl.enable( { emitEvent: false } );
			this.mainContactCtrl.patchValue( this.user.bMainContact, { emitEvent: false } );
		}

		if( this.myInputs.ebeAnrede.options ) {
			const option = this.myInputs.ebeAnrede.options.find( (op:{id:string}) => op.id == this.user.ebeAnrede );
			if( option ) {
				const c = this.formG1.get( 'ebeAnrede' );
				if( c ) {
					c.setValue( option, { emitEvent: false } );
				}
			}
		}

		if( this.myInputs.ebeTitel.options ) {
			const option = this.myInputs.ebeTitel.options.find( (op:{id:string}) => op.id == this.user.ebeTitel );
			if( option ) {
				const c = this.formG1.get( 'ebeTitel' );
				if( c ) {
					c.setValue( option, { emitEvent: false } );
				}
			}
		}

	}


	saveUserObject(): Observable<boolean> {

		if( !this.formG1.valid ) return of(false);

		const userToSave = { ...this.user };
		userToSave.ebeName = this.formG1.value.ebeName || "";
		userToSave.ebeVorname = this.formG1.value.ebeVorname || "";
		userToSave.ebeMail = this.formG1.value.ebeMail || "";
		userToSave.mitgliedId = this.formG1.value.mitgliedId?.id  || "";
		userToSave.ebeAktiv = this.formG1.value.ebeAktiv ? "ja" : "nein";
		userToSave.ansStrasse = this.formG1.value.ansStrasse || "";
		userToSave.ansHausnummer = this.formG1.value.ansHausnummer || "";
		userToSave.ansOrt = this.formG1.value.ansOrt || "";
		userToSave.ansPlz = this.formG1.value.ansPlz || "";
		userToSave.ebeAnrede = this.formG1.value.ebeAnrede?.id || "";
		userToSave.ebeTitel = this.formG1.value.ebeTitel?.id || "";
		userToSave.ebeTelefon = this.formG1.value.ebeTelefon || "";
		userToSave.ebePosition = this.formG1.value.ebePosition || "";


		userToSave.gruppen = [ "MITGLIED" ];
		// userToSave.gruppen = [];
		if( !!this.formG1.value.bAdminMember ) {
			userToSave.gruppen.push( UserRoles.MITGLIED_ADMIN );
		}
		if( !!this.formG1.value.bMaintenanceRights ) {
			userToSave.gruppen.push( UserRoles.MITGLIED_DATENPFLEGE );
		}
		if( !!this.formG1.value.bExportRights ) {
			userToSave.gruppen.push( UserRoles.MITGLIED_DATENEXPORT );
		}

		this.formG1.disable( { emitEvent: false } );
		this.bInProgress = true;

		return this.userService.updateUser( userToSave ).pipe(

			map( (result: Partial<User>) => {

				this.formG1.enable( { emitEvent: false } );
				this.bInProgress = false;

				if( !result ) {
					this.bSaveError = true;
					this.formG1.markAsTouched( { emitEvent: false } );
					return false;
				}

				if( typeof(result) == "number" ) {

					if( result == UserUpdateError.emailAlreadyUsed ) {
						this.emailCtrl.setErrors( { alreadyUsed: true } );
					}
					else if( result == UserUpdateError.emailInvalid ) {
						this.emailCtrl.setErrors( { emailInvalid: true } );
					}

					this.bSaveError = true;
					this.formG1.markAsTouched( { emitEvent: false } );
					this.emailCtrl.markAsTouched( { emitEvent: false } );
					return false;

				}

				if( !result.ebeId ) {
					this.bSaveError = true;
					return false;
				}

				this.formG1.setErrors(null);
				this.bSaveError = false;

				if( result.mitgliedId ) {
					this.mainContactCtrl.enable( { emitEvent: false } );
				}
				else {
					this.mainContactCtrl.disable( { emitEvent: false } );
				}

				if( result.mitgliedId != this._user.mitgliedId ) {
					this._user.bMainContact = false;
					this.mainContactCtrl.patchValue( false, { emitEvent: false } );
				}

				for( const property in result ) {
					if( result.hasOwnProperty(property) ) {
						this._user[ property ] = result[ property ] ?? null;
					}
				}
				this.done.emit( this._user );
				this.formG1.markAsPristine();

				return true;

			} )

		);

	}

	saveMainContact(): Observable<boolean> {

		const bMainContact = this.mainContactCtrl.value || false;
		this.mainContactCtrl.disable( { emitEvent: false });
		this.bInProgress = true;

		return this.memberService.setMitgliedMainContact(
			this._user.ebeId,
			this._user.mitgliedId,
			bMainContact
		).pipe(
			tap( b => {
				this.bInProgress = false;
				if( b ) {
					this._user.bMainContact = bMainContact;
					if( bMainContact ) {
						this.mainPartnerChanged.emit( true );
					}
				}
				this.mainContactCtrl.enable( { emitEvent: false });
			} )
		);

	}

	openPasswordDialog() {

		const dialog = this.matDialog.open( UserChangePasswordDialog, {
			data: { user: this._user }
		});

		dialog.afterClosed().subscribe( (_:any) => {
			console.log('The dialog was closed', _ );
		});

	}

	resetLoginAttempts() {

		this.userService.resetLoginAttempts( this._user.ebeId ).subscribe();

	}



  deleteUserDialog() {
    const dialog = this.matDialog.open(UserDeleteConfirmationDialog, {
      data: {user: this._user}
    });

    dialog.afterClosed().subscribe((b: boolean) => {
      if (b) {
		this.bInProgress = true;
        this.userService.deleteUser(this._user.ebeId).subscribe(() => {
			this.bInProgress = false;
          this.reloadUser.emit(true);
        });
      }
    });
  }
}


export interface UserChangePasswordDialogData {
	user: User;
}


@Component({
	selector: 'user-change-password-dialog',
	template: `<app-change-password
				[user]="dialogData.user"
				(done)="operationDone()"></app-change-password> `
})
export class UserChangePasswordDialog {

	constructor(
		public dialogRef: MatDialogRef<UserChangePasswordDialog>,
		@Inject(MAT_DIALOG_DATA) public dialogData: UserChangePasswordDialogData,
	) {}

      operationDone() {
        this.dialogRef.close();
      }
    }

    export interface UserDeleteConfirmationDialogData {
      user: User;
    }

    @Component({
      selector: 'user-delete-confirmation-dialog',
      template: `
        <app-user-delete-confirmation-dialog
          [user]="dialogData.user"
          (deletedUserId)="operationDone()"></app-user-delete-confirmation-dialog>`
    })
    export class UserDeleteConfirmationDialog {

      @Output() reloadUser = new EventEmitter<boolean>();

      constructor(
        public dialogRef: MatDialogRef<UserChangePasswordDialog>,
        @Inject(MAT_DIALOG_DATA) public dialogData: UserDeleteConfirmationDialogData
      ) {}

      operationDone() {
        this.dialogRef.close();
      }
    }
